// extracted by mini-css-extract-plugin
module.exports = {"label":"Parts_label__2ewdA","image":"Parts_image__2mb23","title":"Parts_title__2e54D","description":"Parts_description__2EY_8","selected":"Parts_selected__2-FHk"};